import { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation, Link  } from 'react-router-dom';
import { useBookpalNavigate } from 'component/common/custom/BookpalLink';

import style from './Refund.module.scss';
import { appSetClose } from 'utils/AppUtil';

function RefundResultFail(props){


    return (
        <>
            {/* <!-- 충전 헤더 --> */}
            <div id="TopHeader" className={"color-bg-01 title_header " + style['TopHeader'] + " " + style['title_header']}>
                
                <div className={"title_menu wrapper " + style['title_menu']}>
                    
                    <div className={"btns left_btns " + style['btns'] + " " + style['left_btns']}></div>
                    <div className={"title-04 color-txt-normal text_overflow " + style['text_overflow'] + " " + style['title-04']}>환불 실패</div>
                    <div className={"btns right_btns " + style['btns'] + " " + style['right_btns']}>
                        <button 
                            type="button" 
                            className={"close_btn " + style['close_btn']} 
                            onClick={()=>{
                                window.close();
                                appSetClose();
                            }}
                            ></button>
                    </div>
                </div>
            </div>

            {/* <!-- container --> */}
            <div id="container" className={"s_wrap wrapper " + style['container'] + " " + style['s_wrap'] + " " + style['wrapper']} style={{marginTop:"0", marginBottom:"0px"}}>
                <section className={"charge_box " + style['charge_box']}>
                    <div className={"area_box " + style['area_box']}>
                        <div className={"center " + style['center']}>
                            <p className="color-txt-normal" style={{textAlign:"center"}}>환불을 진행하지 못했습니다.</p>
                        </div>
                        <div className={"temp_list_type section " + style['temp_list_type'] + " " + style['section']} style={{padding:"0"}}>
                            <div className={"list " + style['list']} > 
                                <div className="list_1" style={{display:""}}>
                                    

                                    <div className={"tit_con section clearfix " + style['tit_con'] } style={{height:"auto",letterSpacing:"0.5px", lineHeight:"1.3",}}>
                                        <div className={"grade_up  radius-sm red_opacity-05 bg " + style['grade_up'] + " " + style['top_con'] + " " + style['bg']} style={{padding:"20px",backgroundColor:"#fff9f0",width:"100%"}}>
                                            <p className={"title body-01 color-txt-muted " + style['title']}><span className="color-txt-normal" style={{fontSize:"0.85rem", lineHeight:"1.0",width:"100%"}}>
                                                <div className={"my_coupon radius-sm bg clearfix " + style['my_coupon']} style={{width:"100%", display:"block",textAlign:"center",alignItems:"center",lineHeight:"1.5"}}>
                                                    <div className={"left " + style['left']} style={{paddingLeft:"0px"}}>
                                                        <p className="title-01-b color-txt-normal" style={{color:"#d5a36d"}}>입금 정보 오류 또는 계좌 문제로 인하여<br />환불이 진행되지 않았습니다.</p>
                                                        <br />
                                                        <p className="title-01-b color-txt-normal" style={{color:"#d5a36d"}}>
                                                            문의 사항이 있으실 경우 <br />
                                                            <span style={{backgroundColor:"#fcecdd",color:"#df8141"}}> [1:1 문의] </span> 
                                                            를 <br />이용해 주시기 바랍니다.
                                                        </p>
                                                    </div>
                                                </div>
                                            </span>
                                            {/* 매월 1일, 최근 3개월 결제금액에 따라 결정됩니다. */}
                                            </p>
                                        </div>
                                        
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        {/* <div className={"center " + style['center']} style={{marginTop:"40px", textDecoration:"underline", color:"#999"}}>
                            <p className="color-txt-normal" style={{textAlign:"center",color:"#999"}}>돌아가기</p>
                        </div> */}
                        
                    </div>
                </section>
            </div>
            {/* <AlertModal /> */}
            {/* <!-- container --> */}

            {/* <Footer /> */}
        </>
    );
}

export default RefundResultFail;